export const URLQueryToString = (query = {}) => {
  // Remove nullish values from query object
  const newQuery = Object.fromEntries(
    Object.entries({ ...query }).map(([k, v]) => [k, v ?? '']),
  );
  return new URLSearchParams(newQuery).toString();
};
